import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DriversWalletService {
  constructor(private http:HttpClient) { }

  driverBalance(data:any){
    return this.http.post(environment.apiUrl+"driver/wallet" , data);
  }

  walletTransaction(data:any){
    return this.http.post(environment.apiUrl+"driver/wallettransaction" , data);
  }


}



